import { LocalStorageCacheStorage } from './local-storage-cache-storage';

export * from './local-storage-cache-storage';

export const cacheStorage = new LocalStorageCacheStorage();
